import { Payer } from "@/src/models/payer";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getAllPayers(): Promise<Payer[]> {
  return fetchJSON<Payer[]>("/api/payer");
}
